import * as React from "react";
import { useFormContext } from "react-hook-form";
import { AutoComplete } from "components";
import { GetPage } from "duck";
import {
  Fragments,
  GetLicensesDocument,
  GetLicensesQuery,
  GetLicensesQueryVariables
} from "requests";
import { FormValues } from "../../duck";

const LicenseAutoComplete: React.FC = () => {
  const { setValue } = useFormContext<FormValues>();

  const getPage = React.useCallback<GetPage<Fragments.License, number>>(
    (client, { perPage, page, ids, search }) =>
      client
        .query<GetLicensesQuery, GetLicensesQueryVariables>({
          query: GetLicensesDocument,
          variables: {
            page,
            perPage,
            filter: ids
              ? { in: { id: ids } }
              : {
                  start: { name: search },
                  equal: { active: true },
                  exists: { deletedAt: false }
                }
          },
          fetchPolicy: "no-cache"
        })
        .then(({ data }) => ({
          collection: data.licenses?.collection || [],
          totalCount: data.licenses?.paginationInfo.totalCount || 0
        })),
    []
  );

  return (
    <AutoComplete
      name="license"
      label="License Type"
      placeholder="License Type"
      getPage={getPage}
      onChange={(value, opt) => {
        setValue("license", value, { shouldValidate: true });
        setValue("licensePeriod", opt?.period || null);
        setValue("startDate", null);
        setValue("expirationDate", null);
        if (opt) {
          setValue("price", opt.price, { shouldValidate: true });
        }
      }}
    />
  );
};

export default LicenseAutoComplete;
